import { useNavigate } from 'react-router-dom';
import React from 'react';
import { Row, Col, Layout, Image, theme } from 'antd';
import './index.scss';
import descriptions from '../../components/descriptions';
//ERAYAK
const { Header, Content, Footer } = Layout;
export const withNavigation = (Component) => {
  return (props) => <Component {...props} navigate={useNavigate()} />;
};

class Profile extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      title: '产业资讯',
    }
  }

  componentDidMount() {
  }
  componentWillReceiveProps(nextProps) {
  }
  render() {
    const  {info_datas}  = descriptions;
    return (
      <Layout style={{ margin: '0 auto' }}>
        <Row justify='center'>
          <Col className='module-content' xs={{ span: 0 }} sm={{ span: 0 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>
            <div className="fadeUp">
              <div className="title-en">INDUSTRY INFORMATION</div>
              <div className="title-cn">产业资讯</div>
            </div>
          </Col>
          <Col className='info-detail' xs={{ span: 18 }} sm={{ span: 18 }} md={{ span: 13 }} lg={{ span: 13 }} xl={{ span: 13 }}>
            <Row justify='start'>
              <Col span={24} style={{ minHeight: '500px'}} >
                <ul className='ul-left'>
                  {info_datas.map((item,indexs)=>{
                    return <li key={indexs}>
                    <div>
                      <p className="news-date">{item.data}</p>
                      <div>
                      <Image style={{margin:'3vh 0'}} src={item.img.default} preview={false}/>
                        <p className="news-title" style={{padding:'0'}}>{item.title}</p>
                      </div>
                    </div>
                  </li>
                  })}
                </ul>
              </Col>
            </Row>
          </Col>
        </Row>
      </Layout>
    )
  }
}


export default withNavigation(Profile);
